/**
 * Texte d'erreur lisible depuis une erreur Axios / API.
 */
export function getApiErrorMessage(error, defaultMessage = 'Une erreur est survenue.') {
  if (!error) return defaultMessage;
  const data = error.response?.data;
  if (!data) return error.message || defaultMessage;

  if (typeof data.error === 'string' && data.error.trim()) {
    return data.error.trim();
  }
  if (typeof data.message === 'string' && data.message.trim()) {
    return data.message.trim();
  }
  if (Array.isArray(data.errors) && data.errors.length > 0) {
    const parts = data.errors
      .map((e) => (e && (e.msg || e.message)) || '')
      .filter(Boolean);
    if (parts.length) return parts.join(' — ');
  }
  if (typeof data === 'string' && data.trim()) return data.trim();
  return defaultMessage;
}
